export default __webpack_public_path__ + "static/media/familyhub.b9b8f82a.png";